import React from 'react';
import { makeStyles } from '@material-ui/core';

import { ReactComponent as Icon } from '#web-components/assets/icons/logoDiia.svg';
import styles from './LogoDiiaIcon.styles';

const useStyles = makeStyles(styles, { name: 'LogoDiiaIcon' });

export default function LogoDiiaIcon() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Icon />
    </div>
  );
}
